import React from 'react'

export default ({ width = 100, height = 100 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <g id="no_connection_icon" transform="translate(-589 -600)">
        <g id="Group_1085" data-name="Group 1085" transform="translate(598 613)">
          <g id="ic_rss_feed_24px" transform="translate(0 8.74)">
            <circle id="Ellipse_9" data-name="Ellipse 9" cx="9.245" cy="9.245" r="9.245" transform="translate(0 47.497)" fill="#c1efe6"/>
            <path id="Path_6" data-name="Path 6" d="M4,4.44v12A53.989,53.989,0,0,1,57.986,70.427h12A66.006,66.006,0,0,0,4,4.44Zm0,24v12A30.008,30.008,0,0,1,33.983,70.427h12A41.971,41.971,0,0,0,4,28.443Z" transform="translate(-4 -4.44)" fill="#c1efe6"/>
          </g>
          <g id="Ellipse_732" data-name="Ellipse 732" transform="translate(33.888)" fill="#c1efe6" stroke="#1f2830" strokeWidth="3">
            <circle cx="23.994" cy="23.994" r="23.994" stroke="none"/>
            <circle cx="23.994" cy="23.994" r="25.494" fill="none"/>
          </g>
          <line id="Line_164" data-name="Line 164" x2="21.115" y2="21.115" transform="translate(47.325 13.437)" fill="none" stroke="#1f2830" strokeWidth="4"/>
          <line id="Line_165" data-name="Line 165" y1="21.115" x2="21.115" transform="translate(47.325 13.437)" fill="none" stroke="#1f2830" strokeWidth="4"/>
        </g>
        <g id="Rectangle_1829" data-name="Rectangle 1829" transform="translate(589 600)" fill="none" stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="100" height="100" stroke="none"/>
          <rect x="0.5" y="0.5" width="99" height="99" fill="none"/>
        </g>
      </g>
    </svg>
  )
}
